module.exports = __webpack_public_path__ + "img/5.d803cd20.png";